import React from 'react';
import "./Footer.css"

export default function Footer() {
  return (
    <div className='Footer'>
        <h2>© Copyright 2K23 CynoSurE-</h2>
        <h3>All Rights Reserved.</h3>
    </div>
  )
}
